/**
 * Application intents sender.
 *
 * @module intent
 */

'use strict';

var app = require('mag-app');


/**
 * Current scheme of event order:
 *
 * HOME/EXIT   -> core hide() -> intent close() -> core hide()
 * BACK/CANCEL -> intent close()
 * OK/ENTER    -> intent done() -> intent close()
 */


/**
 * Open Keyboard.
 *
 * @param {Object} config - configuration for intent
 * @param {Function} [callback] - invoked on successful result
 */
exports.openKeyboard = function ( config, callback ) {
    var done = false;

    core.addListener('hide', function () {
        app.flags.ignoreMessages = true;
    });

    core.intent({
        action: 'keyboard',
        data: {
            title: config.title,
            value: config.value || ''
        },
        events: {
            done: function ( event ) {
                if ( callback ) {
                    callback(event);
                }

                done = true;
            },
            close: function () {
                if ( !done && callback ) {
                    callback({value: config.value});
                }
            }
        }
    }, function ( error ) {
        console.log('Error in keyboard intent: ' + error);
    });
};


/**
 * Send intent to Downloads with given data.
 *
 * @param {Object} config - configuration for intent
 * @param {Function} onClose - close event handler
 */
exports.openDownloads = function ( config, onClose ) {
    core.intent({
        action: 'download',
        data: {
            title: config.title,
            uri:   config.uri
        },
        events: {
            close: onClose
        }
    }, function ( error ) {
        if ( error ) {
            core.notify({
                title: (config.uri ? gettext('Error loading file') + ': ' : '') + error.message,
                icon:  'alert',
                type:  'warning'
            });
        }
    });
};


/**
 * Send intent to Player with given data.
 *
 * @param {Object} config - configuration for intent
 * @param {Function} onClose - close event handler
 */
exports.startPlayback = function ( config, onClose ) {
    core.intent({
        action: 'play',
        mime: config.mime,
        data: {
            title: config.title,
            uri:   config.uri
        },
        events: {
            error: function () {
                console.log('Player error happens!');
            },
            close: onClose
        }
    });
};


/**
 * Open Task Manager.
 *
 * @param {Function} onClose - close event handler
 */
exports.openTaskManager = function ( onClose ) {
    core.intent({
        action: 'taskmanager:show',
        data: {},
        events: {
            close: onClose
        }
    });
};


/**
 * Open System Settings.
 *
 * @param {Function} onClose - close event handler
 */
exports.openSystemSettings = function ( onClose ) {
    core.intent({
        action: 'setup',
        events: {
            close: onClose
        }
    });
};
